'use strict';

var SummaryKpiRibbonReferenceAggregationFactory = function SummaryKpiRibbonReferenceAggregationFactory(AbstractRomKpiRibbonAggregationFactory) {
  function SummaryKpiRibbonReferenceAggregation() {
    AbstractRomKpiRibbonAggregationFactory.call(this, ['rom-summary-reference-mode'], 'kpi-ribbon-reference');
  }
  SummaryKpiRibbonReferenceAggregation.prototype = Object.create(AbstractRomKpiRibbonAggregationFactory.prototype);
  SummaryKpiRibbonReferenceAggregation.constructor = SummaryKpiRibbonReferenceAggregation;
  SummaryKpiRibbonReferenceAggregation.prototype.canAggregate = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType === targetType;
  };
  SummaryKpiRibbonReferenceAggregation.prototype.aggregate = function (data, metricsKeys) {
    var aggregatedData = {};
    if (data.length === 0) {
      return aggregatedData;
    }

    //go through all weeks day and aggregate data
    for (var index = 0, dataLength = data.length; index < dataLength; index++) {
      var item = data[index];
      // put in args the same aggregatedData item and recalculate all values
      aggregatedData = this.iterate(item.week, metricsKeys, aggregatedData);
    }
    return this.calcGap(aggregatedData, true);
  };
  return SummaryKpiRibbonReferenceAggregation;
};
SummaryKpiRibbonReferenceAggregationFactory.$inject = ['AbstractRomKpiRibbonAggregationFactory'];
module.exports = SummaryKpiRibbonReferenceAggregationFactory;